import React from 'react';
import cn from 'clsx';

import Typography from '../../typography/typography';

import { useNavigateTo } from '../../../shared/hooks/hooks';

import styles from './tab.scss';

export interface TabProps {
  className?: string;
  href?: string;
  isSecondary?: boolean;
  isSelected?: boolean;
  onClick?: () => void;
}

function Tab(props: React.PropsWithChildren<TabProps>) {
  const {
    children,
    className,
    href,
    isSecondary,
    isSelected,
    onClick,
    ...otherProps
  } = props;

  const navigateTo = useNavigateTo();

  let tabClassName = 'primary';
  if (isSecondary) {
    tabClassName = 'secondary';
  }

  function handleClick() {
    if (!isSelected) {
      if (href) {
        navigateTo(href);
      }
      typeof onClick === 'function' && onClick();
    }
  }

  return (
    <Typography
      {...otherProps}
      aria-selected={isSelected}
      className={cn(
        isSelected ? styles[tabClassName + '-selected'] : styles[tabClassName],
        `tab ${className} ${isSelected ? 'tab--selected' : 'tab--default'}`
      )}
      onClick={handleClick}
      role="tab"
      tag="button"
    >
      {children}
    </Typography>
  );
}

export default Tab;
